import { ReasonInput } from '@strata/react-compound-inputs';
import { SuggestMultiSelectFormik } from '@strata/react-selects';
import { validationStrings } from '@strata/strata-ui-strings';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { deletePerformanceReqirements } from 'api/performanceAPI';

const ReasonOptions = ['Not Needed', 'Not a New Start'];

export const UpdateReferralDataPerformance = ({ performanceEntries = undefined }) => {
    const performanceOptions = (performanceEntries ?? [])
        .filter(({ status }) => status === 'not-started')
        .map((entry) => ({
            name: entry.value_case_name,
            value: entry.performance_requirement_id,
        }));

    return (
        <>
            <SuggestMultiSelectFormik
                id="performanceRequirements"
                label="Performance Requirement(s) to Remove"
                required
                values={performanceOptions}
                helperText="Only performance requirements that do not have documentation will be included in this list."
            />
            <ReasonInput reasons={ReasonOptions} />
        </>
    );
};

UpdateReferralDataPerformance.propTypes = {
    performanceEntries: PropTypes.arrayOf(PropTypes.shape({})),
};

UpdateReferralDataPerformance.initialValues = () => ({});

UpdateReferralDataPerformance.validationSchema = {
    performanceRequirements: Yup.array()
        .min(1, validationStrings.requiredField.errorMessage)
        .required(validationStrings.requiredField.errorMessage),
    ...ReasonInput.validationSchema,
};

UpdateReferralDataPerformance.onSubmit = async ({ values, referralDetails, username }) =>
    deletePerformanceReqirements({
        payer_id: referralDetails?.payerId,
        referral_id: referralDetails?.referralId,
        performance_requirement_ids: values.performanceRequirements.map(({ value }) => value),
        username,
        ...ReasonInput.submitValues(values),
    });
